export function confirmPasswordValidator(newPassword, confirmPassword, oldPassword) {
    if (!confirmPassword) return "Password can't be empty."
    if (newPassword !== confirmPassword) return 'Passwords must match.'
    if (newPassword === oldPassword) return 'Please select a new password.'
    return ''
  }